import { Injectable } from "@angular/core";
import { HubConnection } from "./hub-connection";
import { LogService } from "../logger/loggerProvider/loggerhelper.service";
import { interval, Observable } from "rxjs";
//SignalR service for creating connection to API supporting SignalR
@Injectable()
export class SignalRService {
  private static counter: number = 0;
  private connections: Map<string, HubConnection> = new Map<string, HubConnection>();
  constructor(private loggerHelper: LogService) {
  }

  //Creates a Hub Connection to the API with the provided clientName
  public createHubConnection(url: string, clientName: string = undefined): HubConnection {
    let id: string = ((clientName !== undefined) ? clientName : "default") + ":" + SignalRService.counter;
    try {
      if (this.connections[id] == undefined) {
        let hubConnection: HubConnection = new HubConnection(id, this.loggerHelper);
        hubConnection.initHubConnection(url);
        this.connections[id] = hubConnection;
        SignalRService.counter++;
      }
      this.loggerHelper.logInfo(SignalRService.name, "createHubConnection called.");
  interval(10000).subscribe(x => {
        this.loggerHelper.logInfo(SignalRService.name, "SignalRService Hub Connection Count :" + SignalRService.counter);
      })
    }
    catch (error) {
      this.loggerHelper.logError(SignalRService.name, error);
    }
    return this.connections[id];
  }
}
